import { render, staticRenderFns } from "./SelfHealing.vue?vue&type=template&id=1493e08e&scoped=true"
import script from "./SelfHealing.vue?vue&type=script&lang=js"
export * from "./SelfHealing.vue?vue&type=script&lang=js"
import style0 from "./SelfHealing.vue?vue&type=style&index=0&id=1493e08e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1493e08e",
  null
  
)

export default component.exports